import axios from 'axios'
import { Toast, Dialog } from 'vant'
import Cookies from 'js-cookie'
import { Loading, ToastMessage, Location } from '@/assets/scripts/helper'
import { IsWechat, wxOAuth, WxOAuthLogin } from '@/assets/scripts/wechat'
import { LOGOUT } from '@/assets/scripts/api'
import $this from '@/main'
import store from '@/store'

window.__axiosPromiseArr = []
/**
 * axios的通用配置
 * https://github.com/axios/axios
 */

// 页面来源
axios.defaults.headers.common['sourceTypeCode'] = 'wechat'
// 请求基础路径
// axios.defaults.baseURL = window.location.protocol + '//' + window.location.host

// 请求超时时间
axios.defaults.timeout = 90000
// `params` are the URL parameters to be sent with the request
// Must be a plain object or a URLSearchParams object
// axios.defaults.params = {clientId: 123456789}
// `withCredentials` indicates whether or not cross-site Access-Control requests
// should be made using credentials
axios.defaults.withCredentials = false
// `maxContentLength` defines the max size of the http response content in bytes allowed
axios.defaults.maxContentLength = 1048576
// `adapter` allows custom handling of requests which makes testing easier.
// Return a promise and supply a valid response (see lib/adapters/README.md).
// axios.defaults.adapter = function (config) {}
// 请求公共参数/错误处理
axios.interceptors.request.use(commonParamsHandler, commonErrorHandler)
axios.interceptors.response.use(businessErrorHandler, httpStatusErrorHandler)

const UN_AUTH_CODES = [
  'token,valid',
  'token,clientId',
  'login,not',
  'login_not',
  '401'
]

const HTTP_STATUS = {
  403: '系统禁止访问',
  404: '系统通讯异常',
  405: '系统禁止访问',
  414: 'URI异常',
  500: '系统内部异常',
  502: '系统通讯异常',
  503: '系统通讯异常',
  504: '网络连接超时'
}

const ERROR_INFO =
  '系统内部异常!'

/**
 * 统一处理接口返回的错误
 * @param response 请求响应对象内容response.config
 * @returns {*}
 */
function businessErrorHandler (rsp) {
  window.__axiosPromiseArr.forEach((obj, index) => {
    if (obj.code === rsp.config.url) {
      window.__axiosPromiseArr.slice(index, 1)
    }
  })
  let { data } = rsp
  if (data.request === '/order/validate.json') return data
  let sid = store.state.initializeSid || store.state.sid
  if (data && UN_AUTH_CODES.indexOf(data.error_code) > -1) {
    // 处理授权/登录超时的情况
      Dialog.alert({
        confirmButtonText: '立即登录',
        message: '您的授权已超时,请重新登录后再试!'
      }).then(async () => {
          Cookies.set('51jk.TK', '')
          await axios.get(LOGOUT)
          Location(wxOAuth(store.state.wxContentUrl + '/index.html?sid='+ sid +'#/login?uri=' + encodeURIComponent(store.state.webContentUrl + $this.$route.fullPath)), true)
           Dialog.close()
      })
    return Promise.reject(data)
  } else if (data && data.error_code === 'login,kickout') {
    axios.get(LOGOUT, {params: {kickout:1}})
    Cookies.set('51jk.TK', '')
    Cookies.set('51jk.CID', '')
    store.commit('setSelf', {})
    Dialog.alert({
      confirmButtonText: '重新登录',
      message:
      '您的账号已经在另一设备登录！\n' +
      '提醒：如非本人操作，则可能泄露密码，重新登录后，可在个人中心-查看个人信息中修改密码。'
    }).then(async () => {
      Location('/wx/index.html?versions=old#/login?code=&state=&uri=' + encodeURIComponent(store.state.webContentUrl + $this.$route.fullPath), true)
    })
    return Promise.reject(data)
  } else if (
    data &&
    data.hasOwnProperty('error_code') &&
    data.hasOwnProperty('error') && data.error_code !== '000000'
  ) {
    showErrorMessage(data.error_code, data.error, data)
    return Promise.reject(data)
  }
  // 返回值支持return Promise.reject(),axios将进入请求的失败回调
  return arguments[0]
}

function httpStatusErrorHandler (error) {
  if (Object.keys(JSON.parse(JSON.stringify(error))).length <= 0) {
    return
  }
  if (error && error.config &&
    /application.json/.test(error.config.headers.Accept) &&
    error.response && error.response.data && error.response.data.hasOwnProperty('error_code') &&
    error.response.data.hasOwnProperty('error') && error.response.data.error_code !== '000000'
  ) {
    return businessErrorHandler(error.response)
  } else if (error.response) {
    Toast({
      type: 'fail',
      duration: 5000, // 持续展示toast 5s
      message: HTTP_STATUS[error.response.status]
    })
  } else if (error.response === undefined) {
    Toast({
      type: 'fail',
      duration: 5000, // 持续展示toast 5s
      message: HTTP_STATUS[504]
    })
  } else {
    Toast({
      type: 'fail',
      duration: 5000, // 持续展示toast 5s
      message: ERROR_INFO
    })
  }
  return Promise.reject(error)
}

/**
 * axios 通用错误处理函数
 * @param error 错误对象
 * @returns {Promise} 返回Promise结果
 */
function commonErrorHandler (error) {
  // 在此处理请求前的错误，通常为http.status错误
  // Do something with request error
  Loading.close()
  return Promise.reject(error)
}

/**
 * 为所有请求加上公共参数和授权信息
 * @param config 请求对象内容request.config
 * @returns {*} 请求对象内容config
 */
function commonParamsHandler (config) {
  config.cancelToken = new axios.CancelToken(cancel => {
    let hasAxios = false
    window.__axiosPromiseArr.forEach((obj, index) => {
      if (obj.code === config.url) {
        window.__axiosPromiseArr.slice(index, 1, {cancel: cancel, code: config.url })
        hasAxios = true
      }
    })
    hasAxios || window.__axiosPromiseArr.push({cancel: cancel, code: config.url })
  })
  config.headers.sid = Cookies.get('51jk._originalSid') || Cookies.get('51jk._sid') || ''
  config.headers.clientId = Cookies.get('51jk.CID') || ''
  config.headers._TOKEN = Cookies.get('51jk.TK') || ''
  config.headers.token = config.headers._TOKEN
  return config
}

function showErrorMessage (code, content, rsp) {
  Toast.clear()
  // 显示请求响应的错误信息
  if (code === 'debug') {
    let errMsg = ERROR_INFO
    if (rsp) {
      if (rsp.error) {
        errMsg = rsp.error.substring(rsp.error.indexOf(':') + 1, rsp.error.length)
      } else if (rsp.request) {
        errMsg = ERROR_INFO + ': \n' + rsp.request
      }
    }
    Toast({
      type: 'fail',
      duration: 5000, // 持续展示toast 5s
      message: errMsg
    })
  } else if (content) {
    let errUrl = rsp.Requested || rsp.request || ''
    Toast({
      type: 'fail',
      duration: 5000, // 持续展示toast 5s
      message: content || ERROR_INFO + ': \n' + errUrl

    })
  } else {
    Toast({
      type: 'fail',
      duration: 5000, // 持续展示toast 5s
      message: ERROR_INFO
    })
  }
}

export default axios
